(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rmc-broadcast-landing"] && !Shopify.designMode) return;
  try {
    
(()=>{
const cleanups=new WeakMap();
function analog(root){const canvas=root.querySelector('canvas.rmc-still__static');const source=root.querySelector('img.rmc-still__bars');const screen=root.querySelector('.rmc-still__broadcast');const ctx=canvas?.getContext('2d',{alpha:false});let raf=0,last=0,start=0;const grain=document.createElement('canvas');grain.width=96;grain.height=96;const g=grain.getContext('2d');function stop(){cancelAnimationFrame(raf);raf=0}function draw(now){if(!root.isConnected||!root.classList.contains('is-tuning'))return;raf=requestAnimationFrame(draw);if(now-last<45)return;last=now;const t=(now-start)/1000,w=canvas.width,h=canvas.height;ctx.fillStyle='#101010';ctx.fillRect(0,0,w,h);if(source?.naturalWidth){const drift=Math.sin(t*11)*h*.22;for(let y=0;y<h;y+=2){const shift=Math.sin(y*.021+t*16)*w*.13+Math.sin(y*.057-t*11)*w*.055+(y>h*.52&&y<h*.59?w*.2:0);const sy=((y+drift+h)%h)/h*source.naturalHeight;const sh=Math.min(source.naturalHeight-sy,source.naturalHeight/h*2);for(const wrap of [-w,0,w])ctx.drawImage(source,0,sy,source.naturalWidth,Math.max(1,sh),shift+wrap,y,w,2)}}const pixels=g.createImageData(96,96);for(let i=0;i<pixels.data.length;i+=4){const v=Math.random()*255;pixels.data[i]=pixels.data[i+1]=pixels.data[i+2]=v;pixels.data[i+3]=255}g.putImageData(pixels,0,0);ctx.globalAlpha=.22;ctx.fillStyle=ctx.createPattern(grain,'repeat');ctx.fillRect(0,0,w,h);ctx.globalAlpha=1;ctx.fillStyle='#0004';for(let y=0;y<h;y+=4)ctx.fillRect(0,y,w,1);const tear=((t*125)%h);ctx.fillStyle='#151515';ctx.fillRect(0,tear,w,h*.045);ctx.globalAlpha=.52;ctx.fillStyle=ctx.createPattern(grain,'repeat');ctx.fillRect(0,tear,w,h*.045);ctx.globalAlpha=1}return{start(){if(!ctx||!g)return;stop();const box=screen.getBoundingClientRect();canvas.height=400;canvas.width=Math.min(640,Math.max(240,Math.round(400*box.width/Math.max(1,box.height))));start=performance.now();last=0;draw(start)},stop}};
function init(root){
  if(cleanups.has(root))return;
  const reduce=matchMedia('(prefers-reduced-motion: reduce)');
  const signal=analog(root);
  const screen=root.querySelector('.rmc-still__broadcast');
  let repeat=0,phase=0,inView=true,disposed=false,count=0,ready=false,opened=false;
  function stop(){clearTimeout(repeat);clearTimeout(phase);signal.stop();root.classList.remove('is-booting','is-tuning')}
  function eligible(){return ready&&!disposed&&root.isConnected&&!reduce.matches&&!document.hidden&&inView}
  function cycle(){
    stop();if(!eligible())return;
    root.dataset.loopCount=String(++count);
    function tune(){
      root.classList.remove('is-booting');if(!eligible())return;
      root.classList.add('is-tuning');signal.start();
      phase=setTimeout(()=>{signal.stop();root.classList.remove('is-tuning')},650);
    }
    if(!opened){opened=true;root.classList.add('is-booting');phase=setTimeout(tune,900)}else tune();
    repeat=setTimeout(cycle,7000);
  }
  function resume(){if(eligible())cycle();else stop()}
  const observer=new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;resume()});
  observer.observe(screen);
  document.addEventListener('visibilitychange',resume);
  reduce.addEventListener('change',resume);
  const cleanup=()=>{disposed=true;stop();observer.disconnect();document.removeEventListener('visibilitychange',resume);reduce.removeEventListener('change',resume);cleanups.delete(root)};
  cleanups.set(root,cleanup);
  Promise.all(Array.from(root.querySelectorAll('.rmc-still__broadcast img')).map(i=>i.decode().catch(()=>{}))).then(()=>{ready=true;resume()});
}
document.querySelectorAll('[data-rmc-loop]').forEach(init);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-rmc-loop]').forEach(init));
document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-rmc-loop]').forEach(root=>cleanups.get(root)?.()));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rmc-password"] && !Shopify.designMode) return;
  try {
    
(()=>{const cleanups=new WeakMap();function analog(root){const canvas=root.querySelector('canvas.tv-static');const source=root.querySelector('img.bars');const screen=root.querySelector('.broadcast');const ctx=canvas?.getContext('2d',{alpha:false});let raf=0,last=0,start=0;const grain=document.createElement('canvas');grain.width=96;grain.height=96;const g=grain.getContext('2d');function stop(){cancelAnimationFrame(raf);raf=0}function draw(now){if(!root.isConnected||!root.classList.contains('channel-switch'))return;raf=requestAnimationFrame(draw);if(now-last<45)return;last=now;const t=(now-start)/1000,w=canvas.width,h=canvas.height;ctx.fillStyle='#101010';ctx.fillRect(0,0,w,h);if(source?.naturalWidth){const drift=Math.sin(t*11)*h*.22;for(let y=0;y<h;y+=2){const shift=Math.sin(y*.021+t*16)*w*.13+Math.sin(y*.057-t*11)*w*.055+(y>h*.52&&y<h*.59?w*.2:0);const sy=((y+drift+h)%h)/h*source.naturalHeight;const sh=Math.min(source.naturalHeight-sy,source.naturalHeight/h*2);for(const wrap of [-w,0,w])ctx.drawImage(source,0,sy,source.naturalWidth,Math.max(1,sh),shift+wrap,y,w,2)}}const pixels=g.createImageData(96,96);for(let i=0;i<pixels.data.length;i+=4){const v=Math.random()*255;pixels.data[i]=pixels.data[i+1]=pixels.data[i+2]=v;pixels.data[i+3]=255}g.putImageData(pixels,0,0);ctx.globalAlpha=.22;ctx.fillStyle=ctx.createPattern(grain,'repeat');ctx.fillRect(0,0,w,h);ctx.globalAlpha=1;ctx.fillStyle='#0004';for(let y=0;y<h;y+=4)ctx.fillRect(0,y,w,1);const tear=((t*125)%h);ctx.fillStyle='#151515';ctx.fillRect(0,tear,w,h*.045);ctx.globalAlpha=.52;ctx.fillStyle=ctx.createPattern(grain,'repeat');ctx.fillRect(0,tear,w,h*.045);ctx.globalAlpha=1}return{start(){if(!ctx||!g)return;stop();const box=screen.getBoundingClientRect();canvas.height=400;canvas.width=Math.min(640,Math.max(240,Math.round(400*box.width/Math.max(1,box.height))));start=performance.now();last=0;draw(start)},stop}};function init(root){if(cleanups.has(root))return;const reduce=matchMedia('(prefers-reduced-motion: reduce)');const signal=analog(root);const frames=Array.from(root.querySelectorAll('.frame'));const phases=['interruption','philosophy','brand','mindset'];const holds=[3000,6000,2500,3000];let timer;let stopped=false;function later(fn,ms){timer=setTimeout(()=>{if(root.isConnected&&!stopped)fn()},ms)}function show(index){frames.forEach((frame,i)=>{frame.classList.toggle('is-current',i===index);frame.setAttribute('aria-hidden',i===index?'false':'true')});root.dataset.phase=phases[index]}function tune(index,duration=650){root.classList.remove('tv-off','channel-switch');show(index);if(root.dataset.tvEffects==='true'){void root.offsetWidth;root.classList.add('channel-switch');signal.start();later(()=>{signal.stop();root.classList.remove('channel-switch');hold(index)},duration)}else hold(index)}function hold(index){later(()=>{if(index<3)tune(index+1);else end()},holds[index])}function on(){signal.stop();root.classList.remove('tv-off','channel-switch');if(root.dataset.tvEffects==='true'){show(0);root.classList.add('booting');later(()=>{root.classList.remove('booting');tune(0,1000)},900)}else tune(0,1000)}function end(){if(root.dataset.tvEffects!=='true'){off();return}root.dataset.phase='closing-signal';root.classList.add('channel-switch');signal.start();later(off,1000)}function off(){signal.stop();root.classList.remove('channel-switch');root.dataset.phase='complete';root.dispatchEvent(new CustomEvent('rmc:intro-finished'))}function play(){clearTimeout(timer);signal.stop();root.classList.remove('playing','booting','tv-on','tv-off','channel-switch','cycling','tv-effects');frames.forEach(f=>{f.classList.remove('is-current');f.removeAttribute('aria-hidden')});if(reduce.matches){root.dataset.phase='philosophy';return}root.classList.add('cycling');if(root.dataset.tvEffects==='true')root.classList.add('tv-effects');on()}const cleanup=()=>{stopped=true;clearTimeout(timer);signal.stop();reduce.removeEventListener('change',play);cleanups.delete(root)};cleanups.set(root,cleanup);Promise.all([document.fonts.ready,...Array.from(root.querySelectorAll('img')).map(i=>i.decode().catch(()=>{}))]).then(()=>{if(!stopped)play()});reduce.addEventListener('change',play)}document.querySelectorAll('[data-rmc-broadcast]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-rmc-broadcast]').forEach(init));document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-rmc-broadcast]').forEach(root=>cleanups.get(root)?.()))})();

  } catch(e) { console.error(e); }
})();
})();
